import { ReactElement } from 'react';
import { useCustomer } from '@adapters/bigcommerce/hooks/customer/index';
import LoggedInContent from './LoggedInContent';
import LoggedOutContent from './LoggedOutContent';

import styles from './AccountMenu.module.scss';

export interface AccountMenuProps {
  onClose?: () => void;
}

const AccountMenu = ({ onClose }: AccountMenuProps): ReactElement => {
  const { customerIsLoggedIn } = useCustomer();

  return (
    <div className={styles.container} role="navigation">
      {!customerIsLoggedIn ? (
        <LoggedOutContent onClose={onClose} />
      ) : (
        <LoggedInContent onClose={onClose} />
      )}
    </div>
  );
};

export default AccountMenu;
